import './Endpage.css';

function Lastpage(){
    return(
        <div id="lastpage">
            <label className='get-touch'>Get in Touch</label>

            <label className='are-looking'>HEY! WE ARE LOOKING FORWARD</label>

            <label className='are-looking'id="start-a">TO START A PROJECT WITH YOU!</label>

            <label className='litora-class'>Etiam sit amet convallis erat – class aptent taciti sociosqu ad litora</label>

            <label className='litora-class'id="gravida-sit">torquent per conubia! Maecenas gravida lacus. Lorem etiam sit</label>

            <label className='litora-class'id="convallis-erat">amet convallis erat.</label>

            <a href="https://www.facebook.com/people/Mukesh-Kumar/pfbid06FLnA4jr1MJykatM7nsJCrkZwKSZZe2Ni5kB1QvceDaDhiTryuDQQhK1yXivos3Vl/"><i class="fa-brands fa-facebook"></i></a>

            <a href="https://twitter.com/"><i class="fa-brands fa-twitter"></i></a>

            <a href="https://www.instagram.com/accounts/login/"><i class="fa-brands fa-instagram"></i></a>

            <a href="https://github.com/ammukeshacademic"><i class="fa-brands fa-github"></i></a>

            <input type="text"placeholder="Please Enter Your Name"id="input-box"></input>

            <input type="text"placeholder="Enter your valid aadress"className='aadress'></input>

            <textarea placeholder="Enter Your Massage"></textarea>

            <button className='submite'>Submit</button>

        </div>
    )
}

export default Lastpage;